export default "__VITE_ASSET__aEL5qHQ7__"